import { useHasFNC, useIsSuperAdmin } from "Flocknote/stateHooks";

export function useShouldShowFamilyInfoInSidebar() {
  const hasFNC = useHasFNC();
  const isSuperAdmin = useIsSuperAdmin();

  // show to everyone if the network has FNC
  // show to Super Admins regardless (they'll see a marketing splash if non-FNC)

  return hasFNC || isSuperAdmin;
}
